import React, { useState, useEffect } from "react";
import { useNavigate } from "react-router-dom";
const Footer = () => {
  let history = useNavigate();
  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);
  return (
    <div>
      <footer
        id="site-footer"
        role="contentinfo"
        class="header-footer-group cust_footer_sec"
      >
        <div class="lazyload footer-top" data-bg="img/Banner-img-6.png">
          <div class="wrapper">
            <div class="row">
              <div class="col-1 cols">
                <span class="heading">Location</span>
                <div class="location-navigation">
                  <div class="menu-footer-location-menu-container">
                    <ul id="location-footer-menu" class="menu">
                      <li
                        id="menu-item-389"
                        class="menu-item menu-item-type-post_type menu-item-object-page menu-item-389"
                      >
                        <a
                          title="Los Angeles"
                          onClick={() => history("/contact-us")}
                          class="menu-image-title-after menu-image-not-hovered"
                        >
                          <noscript>
                            <img
                              width="36"
                              height="36"
                              src="img/location-pin-36x36-1-36x36.png"
                              class="menu-image menu-image-title-after"
                              alt=""
                            />
                          </noscript>
                          <img
                            width="36"
                            height="36"
                            src="img/location-pin-36x36-1-36x36.png"
                            data-src="img/location-pin-36x36-1-36x36.png"
                            class="lazyload menu-image menu-image-title-after"
                            alt=""
                          />
                          <span class="menu-image-title-after menu-image-title">
                            Los Angeles
                          </span>
                        </a>
                      </li>
                      {/* <li
                        id="menu-item-390"
                        class="menu-item menu-item-type-post_type menu-item-object-page menu-item-390"
                      >
                        <a
                          title="New York"
                          onClick={() => history("/contact-us")}
                          class="menu-image-title-after menu-image-not-hovered"
                        >
                          <noscript>
                            <img
                              width="36"
                              height="36"
                              src="sp-ao.shortpixel.ai/client/to_webp%2cq_glossy%2cret_img%2cw_36%2ch_36/https_/www.fugetroncorp.com/wp-content/uploads/2021/10/location-pin-36x36-1-36x36.png"
                              class="menu-image menu-image-title-after"
                              alt=""
                            />
                          </noscript>
                          <img
                            width="36"
                            height="36"
                            src="sp-ao.shortpixel.ai/client/q_lqip%2cret_wait%2cw_36%2ch_36/https_/www.fugetroncorp.com/wp-content/uploads/2021/10/location-pin-36x36-1-36x36.svg"
                            data-src="https://sp-ao.shortpixel.ai/client/to_webp,q_glossy,ret_img,w_36,h_36/https://www.fugetroncorp.com/wp-content/uploads/2021/10/location-pin-36x36-1-36x36.png"
                            class="lazyload menu-image menu-image-title-after"
                            alt=""
                          />
                          <span class="menu-image-title-after menu-image-title">
                            New York
                          </span>
                        </a>
                      </li> */}
                      <li
                        id="menu-item-697"
                        class="menu-item menu-item-type-post_type menu-item-object-page menu-item-697"
                      >
                        <a
                          title="Mexico City"
                          onClick={() => history("/contact-us")}
                          class="menu-image-title-after menu-image-not-hovered"
                        >
                          <noscript>
                            <img
                              width="36"
                              height="36"
                              src="img/location-pin-36x36-1-36x36.png"
                              class="menu-image menu-image-title-after"
                              alt=""
                            />
                          </noscript>
                          <img
                            width="36"
                            height="36"
                            src="img/location-pin-36x36-1-36x36.png"
                            data-src="img/location-pin-36x36-1-36x36.png"
                            class="lazyload menu-image menu-image-title-after"
                            alt=""
                          />
                          <span class="menu-image-title-after menu-image-title">
                            Mexico City
                          </span>
                        </a>
                      </li>
                      <li
                        id="menu-item-391"
                        class="menu-item menu-item-type-post_type menu-item-object-page menu-item-391"
                      >
                        <a
                          title="Mumbai"
                          onClick={() => history("/contact-us")}
                          class="menu-image-title-after menu-image-not-hovered"
                        >
                          <noscript>
                            <img
                              width="36"
                              height="36"
                              src="img/location-pin-36x36-1-36x36.png"
                              class="menu-image menu-image-title-after"
                              alt=""
                            />
                          </noscript>
                          <img
                            width="36"
                            height="36"
                            src="img/location-pin-36x36-1-36x36.png"
                            data-src="img/location-pin-36x36-1-36x36.png"
                            class="lazyload menu-image menu-image-title-after"
                            alt=""
                          />
                          <span class="menu-image-title-after menu-image-title">
                            Mumbai
                          </span>
                        </a>
                      </li>
                    </ul>
                  </div>{" "}
                </div>
              </div>
              <div class="col-2 cols">
                <span class="heading">Service</span>
                <div class="service-navigation">
                  <div class="menu-footer-service-menu-container">
                    <ul id="service-footer-menu" class="menu">
                      <li
                        id="menu-item-264"
                        class="menu-item menu-item-type-post_type menu-item-object-services menu-item-264"
                      >
                        <a
                          title="Application Development"
                          className="menu_nav"
                          onClick={() =>
                            history("/services-application-development")
                          }
                        >
                          Application Development
                        </a>
                      </li>
                      <li
                        id="menu-item-263"
                        class="menu-item menu-item-type-post_type menu-item-object-services menu-item-263"
                      >
                        <a
                          title="Data"
                          className="menu_nav"
                          onClick={() => history("/data")}
                          target=""
                        >
                          Data Modernization & Analytics
                        </a>
                      </li>
                      <li
                        id="menu-item-615"
                        class="menu-item menu-item-type-post_type menu-item-object-services menu-item-615"
                      >
                        <a
                          onClick={() => history("/staff-augmentation")}
                          className="menu_nav"
                        >
                          Managed Services
                        </a>
                      </li>
                      <li
                        id="menu-item-260"
                        class="menu-item menu-item-type-post_type menu-item-object-services menu-item-260"
                      >
                        <a
                          title="Web3 + Blockchain"
                          className="menu_nav"
                          onClick={() => history("/Web3blockchain")}
                        >
                          Blockchain + iOT
                        </a>
                      </li>
                      {/* <li
                        id="menu-item-614"
                        class="menu-item menu-item-type-post_type menu-item-object-services menu-item-614"
                      >
                        <a className="menu_nav" onClick={() => history("/rpa")}>RPA</a>
                      </li> */}

                      {/* <li
                        id="menu-item-616"
                        class="menu-item menu-item-type-post_type menu-item-object-services menu-item-616"
                      >
                        <a className="menu_nav" onClick={() => history("/contact-center")}>
                          Contact Center
                        </a>
                      </li> */}
                    </ul>
                  </div>{" "}
                </div>
              </div>
              <div class="col-3 cols">
                <span class="heading">Company</span>
                <div class="company-navigation">
                  <div class="menu-footer-company-menu-container">
                    <ul id="company-footer-menu" class="menu">
                      {/* <li
                        id="menu-item-355"
                        class="menu-item menu-item-type-post_type menu-item-object-page menu-item-355"
                      >
                        <a
                          title="About Us"
                          className="menu_nav"
                          onClick={() => history("/about-fugetron")}
                        >
                          About Us
                        </a>
                      </li> */}
                      <li
                        id="menu-item-360"
                        class="resource-success-child menu-item menu-item-type-post_type menu-item-object-page menu-item-360"
                      >
                        <a
                          title="Success Stories"
                          className="menu_nav"
                          onClick={() => history("/success-stories")}
                        >
                          Success Stories
                        </a>
                      </li>
                      <li
                        id="menu-item-361"
                        class="menu-item menu-item-type-post_type menu-item-object-page menu-item-361"
                      >
                        <a
                          title="Careers"
                          className="menu_nav"
                          onClick={() => history("/job-opportunities")}
                        >
                          Careers
                        </a>
                      </li>
                      <li
                        id="menu-item-364"
                        class="menu-item menu-item-type-post_type menu-item-object-page menu-item-364"
                      >
                        <a
                          title="Contact Us"
                          className="menu_nav"
                          onClick={() => history("/contact-us")}
                        >
                          Contact Us
                        </a>
                      </li>
                      <li
                        id="menu-item-364"
                        class="menu-item menu-item-type-post_type menu-item-object-page menu-item-364"
                      >
                        <a
                          title="Privacy Policy"
                          className="menu_nav"
                          onClick={() => history("/privacy-policy")}
                        >
                          Privacy policy
                        </a>
                      </li>
                      <li
                        id="menu-item-364"
                        class="menu-item menu-item-type-post_type menu-item-object-page menu-item-364"
                      >
                        <a
                          title="ISO 27001 Certification"
                          className="menu_nav"
                          onClick={() => history("/iso-certificate")}
                        >
                          ISO 27001 Certification
                        </a>
                      </li>
                    </ul>
                  </div>{" "}
                </div>
              </div>
              <div class="col-4 cols">
                <span class="heading">Get In Touch</span>
                <div class="email-contact">
                  <a
                    href="mailto:info@fugetroncorp.com"
                    title="info@fugetroncorp.com"
                  >
                    info@fugetroncorp.com
                  </a>
                </div>
                <div class="social-navigation">
                  <div class="menu-footer-social-menu-container">
                    <ul id="social-menu" class="menu">
                      <li
                        id="menu-item-252"
                        class="menu-item menu-item-type-custom menu-item-object-custom menu-item-252"
                      >
                        <a
                          title="Twitter"
                          target="_blank"
                          rel="no-follow"
                          href="https://twitter.com/FugetronC"
                          class="menu-image-title-after menu-image-not-hovered"
                        >
                          <noscript>
                            <img
                              width="25"
                              height="25"
                              src="img/Component-57-%e2%80%93-1.png"
                              class="menu-image menu-image-title-after"
                              alt=""
                            />
                          </noscript>
                          <img
                            width="25"
                            height="25"
                            src="img/Component-57-%e2%80%93-1.png"
                            data-src="img/Component-57-–-1.png"
                            class="lazyload menu-image menu-image-title-after"
                            alt=""
                          />
                          <span class="menu-image-title-after menu-image-title">
                            Twitter
                          </span>
                        </a>
                      </li>
                      <li
                        id="menu-item-251"
                        class="menu-item menu-item-type-custom menu-item-object-custom menu-item-251"
                      >
                        <a
                          title="Linkedin"
                          target="_blank"
                          rel="no-follow"
                          href="https://www.linkedin.com/in/fugetroncorp/"
                          class="menu-image-title-after menu-image-not-hovered"
                        >
                          <noscript>
                            <img
                              width="25"
                              height="25"
                              src="img/Component-58-%e2%80%93-1.png"
                              class="menu-image menu-image-title-after"
                              alt=""
                            />
                          </noscript>
                          <img
                            width="25"
                            height="25"
                            src="img/Component-58-%e2%80%93-1.png"
                            data-src="img/Component-58-–-1.png"
                            class="lazyload menu-image menu-image-title-after"
                            alt=""
                          />
                          <span class="menu-image-title-after menu-image-title">
                            Linkedin
                          </span>
                        </a>
                      </li>
                      <li
                        id="menu-item-253"
                        class="menu-item menu-item-type-custom menu-item-object-custom menu-item-253"
                      >
                        <a
                          title="Instagram"
                          target="_blank"
                          rel="no-follow"
                          href="https://www.instagram.com/fugetron/"
                          class="menu-image-title-after menu-image-not-hovered"
                        >
                          <noscript>
                            <img
                              width="25"
                              height="25"
                              src="img/Component-59-%e2%80%93-1.png"
                              class="menu-image menu-image-title-after"
                              alt=""
                            />
                          </noscript>
                          <img
                            width="25"
                            height="25"
                            src="img/Component-59-%e2%80%93-1.png"
                            data-src="img/Component-59-–-1.png"
                            class="lazyload menu-image menu-image-title-after"
                            alt=""
                          />
                          <span class="menu-image-title-after menu-image-title">
                            Instagram
                          </span>
                        </a>
                      </li>
                      <li
                        id="menu-item-254"
                        class="menu-item menu-item-type-custom menu-item-object-custom menu-item-254"
                      >
                        <a
                          title="Facebook"
                          target="_blank"
                          rel="no-follow"
                          href="https://www.facebook.com/fugetron/"
                          class="menu-image-title-after menu-image-not-hovered"
                        >
                          <noscript>
                            <img
                              width="25"
                              height="25"
                              src="img/Component-60-%e2%80%93-1.png"
                              class="menu-image menu-image-title-after"
                              alt=""
                            />
                          </noscript>
                          <img
                            width="25"
                            height="25"
                            src="img/Component-60-%e2%80%93-1.png"
                            data-src="img/Component-60-–-1.png"
                            class="lazyload menu-image menu-image-title-after"
                            alt=""
                          />
                          <span class="menu-image-title-after menu-image-title">
                            Facebook
                          </span>
                        </a>
                      </li>
                    </ul>
                  </div>{" "}
                </div>
              </div>
            </div>
          </div>
        </div>
        <div class="footer-bottom">
          <div class="wrapper">
            <span>
              Copyright © 2025 Fugetron. Designed and Developed by Fugetron
              Corporation.
            </span>
          </div>
        </div>
      </footer>
    </div>
  );
};

export default Footer;
